"use strict";

import { profileConstants } from "../_constants";

const INITIAL_PROFILE_DATA_STATE = {
  profileData: {},
  profileUpdateSucess: false,
};

export function profile(state = INITIAL_PROFILE_DATA_STATE, action) {
  switch (action.type) {
    case profileConstants.GET_PROFILE_DETAILS_REQUEST:
      return {
        ...state,
        profileData: {},
        profileUpdateSucess: false,
      };

    case profileConstants.GET_PROFILE_DETAILS_COMPLETE:
      return {
        ...state,
        profileData: action.payload.data,
        profileUpdateSucess: false,
      };

    case profileConstants.GET_PROFILE_DETAILS_ERROR:
      return {
        ...state,
        profileData: {},
        profileUpdateSucess: false,
      };

    case profileConstants.UPDATE_DISPLAY_NAME_REQUEST:
      return {
        ...state,
        profileUpdateSucess: false,
      };

    case profileConstants.UPDATE_DISPLAY_NAME_COMPLETE:
      return {
        ...state,
        profileUpdateSucess: !!action.payload?.data?.customer?.nickname,
      };

    case profileConstants.UPDATE_PROFILE_PICTURE_COMPLETE:
      return {
        ...state,
        profileUpdateSucess:
          !!action.payload?.data?.response?.profilePicturePath,
      };
  }

  return state;
}
